import React from "react"
import { Container, Row, Col } from "reusecore/Layout"
import Box from "reusecore/Box"
import Heading from "reusecore/Heading"
import Text from "reusecore/Text"
import Counter from "reusecore/Counter"
import { SectionTitle, SectionBackground } from "reusecore/SectionTitle"
import walletImage from "assets/images/robot_parts.png"
import SectionParticle from "assets/images/particles/crypto-managment-wallet.svg"
import data from "assets/data/wallet"
import WalletSectionWrapper from "./wallet.style"

const ReWallet = ({title, text1, text2, metrics, ImageWallet}) => {
  return (
    <WalletSectionWrapper id="scrapys">
      <Container>
        <img
          src={SectionParticle}
          className="section__particle"
          alt="cryptik"
        />
        <Row>
          <Col className="lg-5 md-4 xs-12">
            <Box className="wallet-image">
              <img src={ImageWallet} alt="cryptik wallet image" />
            </Box>
          </Col>
          <Col className="lg-6 offset-lg-1 md-8 xs-12">
            <Box className="wallet-left-content">
              <SectionTitle>
                <SectionBackground>
                  <Heading> {title}</Heading>
                </SectionBackground>
                <Text>
                {text1}
                </Text>
                <Text>
                {text2}  
                </Text>
              </SectionTitle>

              <Box className="wallet-info">
                {metrics.wallet.map((item, index) => (
                  <Box className="counter-item" key={index}>
                    <Counter end={item.count} suffix={item.suffixText} />
                    <Text>{item.body}</Text>
                  </Box>
                ))}
              </Box>
            </Box>
          </Col>
        </Row>
      </Container>
    </WalletSectionWrapper>
  )
}

export default ReWallet
